import '#/src/assets/scss/main.scss'

export {Layout}

function Layout({children}) {
  return children;
}